import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {RootState} from './store/models';
import {initState} from './store/stateinit';
import storePlugins from './store/plugins/index';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
    state: {
        countryData: initState('countrydata'),
        options: initState('settings'),
    },
    plugins: storePlugins,
};

export default new Vuex.Store<RootState>(store);
